document.addEventListener('DOMContentLoaded', function() {
  let isHeaderCartRefreshInFlight = false;

  function refreshAjaxCartFromHeaderBubble() {
    if (isHeaderCartRefreshInFlight) return;

    const canUpdate = typeof window.liquidAjaxCart?.update === 'function';
    const canGet = typeof window.liquidAjaxCart?.get === 'function';
    if (!canUpdate && !canGet) return;

    isHeaderCartRefreshInFlight = true;
    if (canUpdate) {
      window.liquidAjaxCart.update(
        {},
        {
          lastCallback: () => {
            isHeaderCartRefreshInFlight = false;
          },
        }
      );
      return;
    }

    Promise.resolve(window.liquidAjaxCart.get())
      .catch(() => {})
      .finally(() => {
        isHeaderCartRefreshInFlight = false;
      });
  }

  function handleCartQuantityClick(button, action) {
    const container = button.closest('ajax-cart-quantity');
    if (!container) return;
    
    const hasPackAttribute = container.hasAttribute('game-day-socks-bundle');
    if (!hasPackAttribute) {
      return;
    }
    
    const quantityInput = container.querySelector('input');
    const cartItem = container.closest('.cart-item');
    if (!quantityInput || !cartItem) return;
    
    const packInfo = container.getAttribute('data-pack-info');
    if ((parseInt(packInfo) == parseInt(quantityInput.value)) && action == 'minus') return;
    
    let packStep = 1;
    if (packInfo) {
      const numberMatch = packInfo.match(/\d+/);
      if (numberMatch) {
        packStep = parseInt(numberMatch[0]);
      } else {
        const wordToNumber = {
          'one': 1, 'three': 3, 'five': 5, 'seven': 7, 'nine': 9, 'eleven': 11
        };
        const word = packInfo.split('-')[0].toLowerCase();
        packStep = wordToNumber[word] || 1;
      }
    }
    
    const currentQuantity = parseInt(quantityInput.value) || 0;
    let newQuantity;
    
    if (action === 'plus') {
      newQuantity = currentQuantity + packStep;
    } else {
      newQuantity = Math.max(packStep, currentQuantity - packStep);
    }
    
    updateCartQuantity(newQuantity, quantityInput);
  }
  
  function updateCartQuantity(newQuantity, quantityInput) {
    quantityInput.value = newQuantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncTiloFreeSockQuantity(container, action) {
    const freeLineIndexRaw = container.getAttribute('data-tilo-free-line-index');
    const freeLineIndex = freeLineIndexRaw ? parseInt(freeLineIndexRaw, 10) : NaN;
    const freeLineKey = container.getAttribute('data-tilo-free-line-key') || '';
    const parentLineKey = container.getAttribute('data-tilo-parent-line-key') || '';
    if (!freeLineIndex || Number.isNaN(freeLineIndex)) {
      return false;
    }

    const quantityInput = container.querySelector('input[data-ajax-cart-quantity-input]');
    if (!quantityInput) return false;

    const parentLineIndexRaw = quantityInput.getAttribute('data-ajax-cart-quantity-input');
    const parentLineIndex = parentLineIndexRaw ? parseInt(parentLineIndexRaw, 10) : NaN;
    if (!parentLineIndex || Number.isNaN(parentLineIndex)) return false;

    const currentQuantity = parseInt(quantityInput.value, 10) || 0;
    const newQuantity = action === 'plus' ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);

    const runSequentialFallback = () => {
      if (typeof window.liquidAjaxCart?.change !== 'function') return;
      window.liquidAjaxCart.change(
        { line: parentLineIndex, quantity: newQuantity },
        {
          lastCallback: () => {
            window.liquidAjaxCart.change(
              { line: freeLineIndex, quantity: newQuantity }
            );
          },
        }
      );
    };

    if (typeof window.liquidAjaxCart?.update !== 'function') {
      runSequentialFallback();
      return true;
    }

    const root =
      (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';

    if (parentLineKey && freeLineKey) {
      const updates = {
        [parentLineKey]: newQuantity,
        [freeLineKey]: newQuantity,
      };
      window.liquidAjaxCart.update({ updates });
      return true;
    }

    fetch(`${root}cart.js`)
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load cart');
        return response.json();
      })
      .then((cart) => {
        const items = Array.isArray(cart?.items) ? cart.items : [];
        const parentItem = items[parentLineIndex - 1];
        const freeItem = items[freeLineIndex - 1];
        if (!parentItem?.key || !freeItem?.key) throw new Error('Missing cart line keys');

        const updates = {
          [parentItem.key]: newQuantity,
          [freeItem.key]: newQuantity,
        };
        window.liquidAjaxCart.update({ updates });
      })
      .catch(() => {
        runSequentialFallback();
      });

    return true;
  }

  function syncTiloFreeSockRemoval(removeBtn) {
    const cartItem = removeBtn.closest('.cart-item');
    if (!cartItem) return false;

    const container = cartItem.querySelector(
      'ajax-cart-quantity[data-tilo-parent-line-key][data-tilo-free-line-key]'
    );
    if (!container) return false;

    const parentLineKey = container.getAttribute('data-tilo-parent-line-key') || '';
    const freeLineKey = container.getAttribute('data-tilo-free-line-key') || '';
    if (!parentLineKey || !freeLineKey || parentLineKey === freeLineKey) return false;

    if (typeof window.liquidAjaxCart?.update === 'function') {
      const updates = {
        [parentLineKey]: 0,
        [freeLineKey]: 0,
      };
      window.liquidAjaxCart.update({ updates });
      return true;
    }

    const quantityInput = container.querySelector('input[data-ajax-cart-quantity-input]');
    const parentLineIndexRaw = quantityInput?.getAttribute('data-ajax-cart-quantity-input');
    const parentLineIndex = parentLineIndexRaw ? parseInt(parentLineIndexRaw, 10) : NaN;
    const freeLineIndexRaw = container.getAttribute('data-tilo-free-line-index');
    const freeLineIndex = freeLineIndexRaw ? parseInt(freeLineIndexRaw, 10) : NaN;

    if (
      typeof window.liquidAjaxCart?.change === 'function' &&
      parentLineIndex &&
      !Number.isNaN(parentLineIndex) &&
      freeLineIndex &&
      !Number.isNaN(freeLineIndex)
    ) {
      window.liquidAjaxCart.change(
        { line: parentLineIndex, quantity: 0 },
        {
          lastCallback: () => {
            window.liquidAjaxCart.change({ line: freeLineIndex, quantity: 0 });
          },
        }
      );
      return true;
    }

    return false;
  }
  
  document.addEventListener('click', function(e) {
    const headerCartBubble = e.target.closest('[id="header-cart-bubble"]');
    if (headerCartBubble) {
      refreshAjaxCartFromHeaderBubble();
    }

    const removeBtn = e.target.closest('[data-ajax-cart-request-button]');
    const plusBtn = e.target.closest('[data-ajax-cart-quantity-plus]');
    const minusBtn = e.target.closest('[data-ajax-cart-quantity-minus]');

    if (removeBtn && syncTiloFreeSockRemoval(removeBtn)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    if (plusBtn) {
      const container = plusBtn.closest('ajax-cart-quantity');
      if (!container) return;

      if (syncTiloFreeSockQuantity(container, 'plus')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      if (container.hasAttribute('game-day-socks-bundle')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        handleCartQuantityClick(plusBtn, 'plus');
      }
    }
    
    if (minusBtn) {
      const container = minusBtn.closest('ajax-cart-quantity');
      if (!container) return;

      if (syncTiloFreeSockQuantity(container, 'minus')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      if (container.hasAttribute('game-day-socks-bundle')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        handleCartQuantityClick(minusBtn, 'minus');
      }
    }
  }, true);

});